



























































































































































































































































import SimpleMap from '../../core/components/SimpleMap.vue';
import ModalViewSegments from './ModalViewSegments.vue';
import vColumnsResizable from '../../../plugins/vue-columns-resizable'
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    getDateFromDateFormatApi,
    parseFloatNumber,
    tableSort,
    itemsPerPageOptionsTable
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import {
    booleanFormatter,
    formattedDate,
    getOnlyDateFromTimestamp,
    nullFormatter
} from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalCompanyHarvest from './ModalCompanyHarvest.vue';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { dateFormat } from 'highcharts';
import { getTooltipForCalibrationPeriods } from '../helpers';
import { getValueParsedByType, unitsValuesChoices, unitValues } from '../../../features/core/api';

@Component({
    directives: {
        'v-columns-resizable': vColumnsResizable,
    },
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        DatePickerRange,
        Button,
        SimpleTable,
        DeleteConfirmation,
        ModalViewSegments
    }
})
export default class SegmentsTable extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    itemsPerPageOptions: Array<number> = itemsPerPageOptionsTable;
    @Prop() vehicleFilterSelected: any;
    @Prop({
        default() {
            return [];
        }
    })
    itemsSegments: Array<object>;
    @Prop({ default: '' }) tableClass: Array<object>;
    selectedWorkSegments: Array<object> = [];
    @Prop({ default: -1 }) harvestId: number;
    @Prop({ default: false }) isSowing: boolean;
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: false }) simulation: boolean;
    @Prop({ default: false }) ranchIsClosed: boolean;
    pendingSegment: boolean = false;
    cancelTokenLoadSegment: any = null;
    visibleModalViewSegments: boolean = false;
    vehicleID: number = -1;
    colorReferences: Array<object> = [
        {
            color: '#e9ac76',
            value: 'Segmento de Resiembra'
        },
    ];
    headersSimulation: Array<object> = [
        {
            text: 'Fecha Inicio',
            value: 'start_date',
            sortable: true,
            width: '200px'
        },
        {
            text: 'Fecha Fin',
            value: 'end_date',
            sortable: true,
            width: '200px'
        },
        {
            text: 'Area cosechada',
            value: 'harvested_area',
            unit: unitValues[unitsValuesChoices.area],
            align: 'center',
            sortable: true
        },
        {
            text: 'Rendimiento',
            value: 'old_performance',
            unit: unitValues[unitsValuesChoices.performance],
            sortable: true,
            align: 'center',
            class: 'text-orange'
        },
        {
            text: 'Humedad',
            value: 'old_humidity',
            unit: unitValues[unitsValuesChoices.humidity],
            align: 'center',
            sortable: true,
            class: 'text-orange'
        },
                {
            text: 'Factor Cal. Rinde (%)',
            value: 'old_performance_calibration_factor',
            align: 'center',
            sortable: true,
            class: 'text-orange'
        },
        {
            text: 'Factor Cal. Humedad (%)',
            value: 'old_humidity_calibration_factor',
            sortable: true,
             align: 'center',
            class: 'text-orange'
        },
        {
            text: 'Rendimiento',
            value: 'new_performance',
            unit: unitValues[unitsValuesChoices.performance],
            sortable: true,
            align: 'center',
            class: 'text-green'
        },
        {
            text: 'Humedad',
            value: 'new_humidity',
            unit: unitValues[unitsValuesChoices.humidity],
            sortable: true,
            align: 'center',
            class: 'text-green'
        },
        {
            text: 'Factor Cal. Rinde (%)',
            value: 'new_performance_calibration_factor',
            align: 'center',
            sortable: true,
            class: 'text-green'
        },
        {
            text: 'Factor Cal. Humedad (%)',
            value: 'new_humidity_calibration_factor',
            align: 'center',
            sortable: true,
            class: 'text-green'
        },
    ];
    headersSegments: Array<object> = [
        {
            text: 'Máquina',
            value: 'vehicle',
            sortable: true,
            align: 'center',
            filter: this.filterSegmentsByVehicle
        },
        {
            text: 'Fecha Inicio',
            value: 'start',
            sortable: true,
            width: '200px'
        },
        {
            text: 'Fecha Fin',
            value: 'end',
            sortable: true,
            width: '200px'
        },
        {
            text: 'Area cosechada',
            value: 'harvested_area',
            unit: unitValues[unitsValuesChoices.area],
            sortable: true,
        },
        {
            text: 'Rendimiento',
            value: 'performance',
            unit: unitValues[unitsValuesChoices.performance],
            sortable: true
        },
        {
            text: 'Humedad',
            value: 'humidity',
            unit: unitValues[unitsValuesChoices.humidity],
            sortable: true
        },
        {
            text: 'Area cosechada cruda',
            value: 'raw_area',
            unit: unitValues[unitsValuesChoices.area],
            sortable: true,
        },
        {
            text: 'Area solapada',
            value: 'overlapped_area',
            unit: unitValues[unitsValuesChoices.area],
            sortable: true
        },
        {
            text: 'Factor Calibración (%)',
            value: 'performance_calibration_periods',
            align: 'center',
            sortable: true
        },
        
        {
            text: 'Rendimiento (s/cal)',
            value: 'uncalibrated_performance',
            unit: unitValues[unitsValuesChoices.performance],
            sortable: true
        },
        
        {
            text: 'Humedad (s/cal)',
            value: 'uncalibrated_humidity',
            unit: unitValues[unitsValuesChoices.humidity],
            sortable: true
        },
        {
            text: 'Variable',
            value: 'variable',
            sortable: true
        }
    ];
    clickedSegmentCompanyID: number = -1;
    segmentInfo: object | null = null;
    headers: Array<object> = [];

    seeVehicleDetail(item){
        if(!this.isCarrier){
            this.viewVehicleDetail(item)
        }
    }

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    get getFilteredHeaders() {
        let headers = JSON.parse(JSON.stringify(this.headers));

        if(this.isCarrierLimited && !this.ranchIsClosed){
            headers = headers.filter(header => header['value'] !== 'performance');
            headers = headers.filter(header => header['value'] !== 'humidity');
            headers = headers.filter(header => header['value'] !== 'uncalibrated_performance');
            headers = headers.filter(header => header['value'] !== 'uncalibrated_humidity');
            headers = headers.filter(header => header['value'] !== 'performance_calibration_periods');
        }
        return headers;
    }

    @Watch('isCarrier', { immediate: true })
    @Watch('isCarrierLimited', { immediate: true })
    watchIsCarrier(value) {
        if (value) {
            this.hideHeadersToInsuranceCarrier();
        }
    }


    mounted() {
        if (!this.simulation) {
            let headers = this.headersSegments;
            if (this.isSowing) {
                headers[3]['text'] = 'Area sembrada';
                headers[3]['value'] = 'sown_area';
                headers[4]['class'] = 'hide-header';
                headers[4]['align'] = ' d-none';
                headers = headers.splice(6, 6);
            }
            this.headers = this.headersSegments;
        } else {
            this.headers = this.headersSimulation;
        }

        
    }

    hideHeadersToInsuranceCarrier(){
        if(this.isCarrier){
            let indiceInicial = 6;
            let numeroElementosAEliminar = this.headers.length - indiceInicial;
            // console.log("numeroElementosAEliminar", numeroElementosAEliminar)
            this.headers.splice(indiceInicial, numeroElementosAEliminar);
            
        }
    }

    rowClass(item){
        let rowCss = 'truncate-row';

        if(item && item['resowing']){
            rowCss += ' table-row-orange-light'
        }
        
        rowCss += ' table-row-white'
      return rowCss
    }

    customSort(items: object[], sortBy: string[], sortDesc: boolean[]) {
        return tableSort(items, sortBy, sortDesc)
    }

    get isCarrierLimited(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER_LIMITED];
    }

    get getFilteredSegments() {
        let segments = JSON.parse(JSON.stringify(this.itemsSegments));
        if(this.isCarrierLimited && !this.ranchIsClosed){
            segments = segments.map(segment => {
               return {
                ...segment,
                performace: '-',
                humidity: '-',
                uncalibrated_humidity: '-',
                uncalibrated_performance: '-',
               }
            });
        }
        return segments
    }

    @Emit()
    selectedWorkSegment() {}

    @Emit()
    viewVehicleDetail(item) {}

    clearSelectedWorkSegments() {
        this.selectedWorkSegments = [];
    }

    addSegmentToSelectedOnes(segmentToAdd) {
        let indexSegmentInSelectedOnes = this.selectedWorkSegments.findIndex(
            segment => segment['customId'] === segmentToAdd['customId']
        );
        if (indexSegmentInSelectedOnes == -1) {
            this.selectedWorkSegments.push(segmentToAdd);
        }
    }

    selectAllSegments(item) {
        if (!item['value']) {
            this.selectedWorkSegments = [];
        }
    }

    @Emit()
    selectedSegments(elements) {
        return elements;
    }

    @Watch('selectedWorkSegments')
    observableSelectedElements(elements) {
        this.selectedSegments(elements);
    }

    closeSegmentModal() {
        this.segmentInfo = null;
        if (this.cancelTokenLoadSegment) {
            this.cancelTokenLoadSegment.cancel();
            this.cancelTokenLoadSegment = null;
        }
        this.visibilityModalViewSegment(false);
    }

    @Watch('vehicleFilterSelected')
    observableVehicleFilter(value) {
        this.filterSegmentsByVehicle(value);
    }

    filterSegmentsByVehicle(value) {
        return this.vehicleFilterSelected == null ? true : value['id'] === this.vehicleFilterSelected['id'];
    }

    getTooltipCalibrationPeriod(items, isPerformance: boolean) {
        return getTooltipForCalibrationPeriods(items, isPerformance)
    }

    dateFormatter(value) {
        return formattedDate(value, true);
    }

    parseCalibrationFactor(value, decimals?) {
        let dec = decimals ? decimals : 1; 
        return parseFloatNumber(value, dec);
    }

    parseNumber(value, key) {
        if(value == null){
            return '-'
        }
        return getValueParsedByType(value, unitsValuesChoices[key]);
    }

    viewClickedSegment(clickedSegment) {
        if(!this.isSowing && !this.isCarrier){
            this.vehicleID = clickedSegment['vehicle']['id'];
            let harvestId = this.harvestId;
            let parameters = {
                vehicle: clickedSegment['vehicle']['id'],
                start_date: clickedSegment['start'] == undefined ? clickedSegment['start_date'] : clickedSegment['start'],
                end_date: clickedSegment['end'] == undefined ? clickedSegment['end_date'] : clickedSegment['end'],
                ...(harvestId !== -1 ? { harvest: harvestId } : {})
            };
            this.getSegmentInfo(parameters);
        }
    }

    visibilityModalViewSegment(value) {
        this.visibleModalViewSegments = value;
    }

    pendingRequestSegment(value) {
        this.pendingSegment = value;
    }

    getSegmentInfo(parameters) {
        // console.log("getSegmentInfo", parameters);
        this.visibilityModalViewSegment(true);
        this.pendingRequestSegment(true);
        this.cancelTokenLoadSegment = Axios.CancelToken.source();
        InsuranceServices.getHarvestVehicleSegment(this.cancelTokenLoadSegment, parameters)
            .then(response => {
                response['vehicle_id'] = parameters['vehicle'];
                if (response['vehicle'] && response['vehicle']['company'] && response['vehicle']['company']['id']) {
                    this.clickedSegmentCompanyID = response['vehicle']['company']['id'];
                }
                this.segmentInfo = response;
                this.pendingRequestSegment(false);
            })
            .catch(error => {
                this.clickedSegmentCompanyID = -1;
                this.pendingRequestSegment(false);
                let msg = '';

                if (error && error.response && error.response.data && error.response.data.message) {
                    msg = error.response.data.message;
                } else {
                    msg = 'Ocurrio un error';
                }
                this.segmentInfo = {
                    error: msg
                };
            });
    }
}
